define('presentation/settings/liveReceptionistScripts/viewModels/liveReceptionistScriptTransferOptionsTabViewModel',[
        'businessServices/authentication/sessionAccountInfo',
        'common/promises/promiseFactory',
        'common/collections/collectionSorter',
        'constants/liveReceptionistScriptWarmTransferCallerIdConstants',
        'constants/liveReceptionistScriptTransferOptionConstants',
        'constants/liveReceptionistScriptTransferSelectionTypeConstants'
    ],
    function () {
        return function () {
            const self = this;

            const CollectionSorterConstructor = require('common/collections/collectionSorter');
            const _sorter = new CollectionSorterConstructor();

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const LiveReceptionistWarmTransferCallerIdConstants = require('constants/liveReceptionistScriptWarmTransferCallerIdConstants');
            const LiveReceptionistTransferOptionConstants = require('constants/liveReceptionistScriptTransferOptionConstants');
            const LiveReceptionistScriptTransferSelectionTypeConstants = require('constants/liveReceptionistScriptTransferSelectionTypeConstants');

            const _i18n = require('i18next');
            const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

            let _disposables = [];

            const _onUserTransferOptionChange = () => {
                const selectedOption = self.selectedUserTransferOption();
                if (selectedOption === LiveReceptionistTransferOptionConstants.Unknown || selectedOption === LiveReceptionistTransferOptionConstants.None) {
                    self.showSelectUserSelectionTypes(false);
                    self.showUserSelection(false);
                    return;
                }
                self.showSelectUserSelectionTypes(true);

                _onUserTransferSelectionTypeChange();
            };

            const _onUserTransferSelectionTypeChange = () => {
                const selectedOption = self.selectedUserTransferSelectionType();
                self.showUserSelection(selectedOption === LiveReceptionistScriptTransferSelectionTypeConstants.Manual);
            };

            const _onUserGroupTransferOptionChange = () => {
                const selectedOption = self.selectedUserGroupTransferOption();
                if (selectedOption === LiveReceptionistTransferOptionConstants.Unknown || selectedOption === LiveReceptionistTransferOptionConstants.None) {
                    self.showSelectUserGroupSelectionTypes(false);
                    self.showUserGroupSelection(false);
                    return;
                }
                self.showSelectUserGroupSelectionTypes(true);

                _onUserGroupTransferSelectionTypeChange();
            };

            const _onUserGroupTransferSelectionTypeChange = () => {
                const selectedOption = self.selectedUserGroupTransferSelectionType();
                self.showUserGroupSelection(selectedOption === LiveReceptionistScriptTransferSelectionTypeConstants.Manual);
            };

            const _onForwardingNumberTransferOptionChange = () => {
                const selectedOption = self.selectedForwardingNumberTransferOption();
                if (selectedOption === LiveReceptionistTransferOptionConstants.Unknown || selectedOption === LiveReceptionistTransferOptionConstants.None) {
                    self.showSelectForwardingNumberSelectionTypes(false);
                    self.showForwardingNumberSelection(false);
                    return;
                }
                self.showSelectForwardingNumberSelectionTypes(true);

                _onForwardingNumberSelectionTypeChange();
            };

            const _onForwardingNumberSelectionTypeChange = () => {
                const selectedOption = self.selectedForwardingNumberTransferSelectionType();
                self.showForwardingNumberSelection(selectedOption === LiveReceptionistScriptTransferSelectionTypeConstants.Manual);
            };

            const _onVoicemailBoxTransferOptionChange = () => {
                const selectedOption = self.selectedVoicemailBoxTransferOption();
                if (selectedOption === LiveReceptionistTransferOptionConstants.Unknown || selectedOption === LiveReceptionistTransferOptionConstants.None) {
                    self.showSelectVoicemailBoxSelectionTypes(false);
                    self.showVoicemailBoxSelection(false);
                    return;
                }
                self.showSelectVoicemailBoxSelectionTypes(true);

                _onVoicemailBoxSelectionTypeChange();
            };

            const _onVoicemailBoxSelectionTypeChange = () => {
                const selectedOption = self.selectedVoicemailBoxTransferSelectionType();
                self.showVoicemailBoxSelection(selectedOption === LiveReceptionistScriptTransferSelectionTypeConstants.Manual);
            };

            const _filterAvailableSelections = (allSubscribers, selectedSubscribers, propertyPath) => {
                _sorter.sort(allSubscribers, propertyPath, true);

                return allSubscribers.filter((subscriber) => {
                    return undefined === selectedSubscribers.find((selectedSubscriber) => {
                        return subscriber.id === selectedSubscriber().id;
                    });
                });
            };

            self.availableTransferCallerIds = [
                {id: LiveReceptionistWarmTransferCallerIdConstants.CustomerServiceNumber, text: _i18n.t('addLiveReceptionistScript:customerServiceNumber')},
                {id: LiveReceptionistWarmTransferCallerIdConstants.CallersNumber, text: _i18n.t('addLiveReceptionistScript:callerNumber')},
                {id: LiveReceptionistWarmTransferCallerIdConstants.HostedNumber, text: _i18n.t('addLiveReceptionistScript:dialedNumber')}
            ];
            self.selectedTransferCallerId = ko.observable(LiveReceptionistWarmTransferCallerIdConstants.HostedNumber);

            self.availableTransferOptions = [
                {id: LiveReceptionistTransferOptionConstants.None, text: _i18n.t('addLiveReceptionistScript:transferOptionNone')},
                {id: LiveReceptionistTransferOptionConstants.WarmOnly, text: _i18n.t('addLiveReceptionistScript:transferOptionWarm')},
                {id: LiveReceptionistTransferOptionConstants.ColdOnly, text: _i18n.t('addLiveReceptionistScript:transferOptionCold')},
                {id: LiveReceptionistTransferOptionConstants.WarmAndCold, text: _i18n.t('addLiveReceptionistScript:transferOptionWarmAndCold')}
            ];
            self.availableForwardingNumberTransferOptions = ko.observableArray(self.availableTransferOptions);
            self.availableVoicemailBoxTransferOptions = ko.observableArray([
                {id: LiveReceptionistTransferOptionConstants.None, text: _i18n.t('addLiveReceptionistScript:transferOptionNone')},
                {id: LiveReceptionistTransferOptionConstants.ColdOnly, text: _i18n.t('addLiveReceptionistScript:transferOptionCold')}
            ]);

            self.selectedManualEntryTransferOption = ko.observable(LiveReceptionistTransferOptionConstants.None);
            self.selectedUserTransferOption = ko.observable(LiveReceptionistTransferOptionConstants.None);
            self.selectedUserGroupTransferOption = ko.observable(LiveReceptionistTransferOptionConstants.None);
            self.selectedForwardingNumberTransferOption = ko.observable(LiveReceptionistTransferOptionConstants.None);
            self.selectedVoicemailBoxTransferOption = ko.observable(LiveReceptionistTransferOptionConstants.None);

            self.showSelectUserSelectionTypes = ko.observable(false);
            self.availableUserTransferSelectionTypes = [
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.All, text: _i18n.t('addLiveReceptionistScript:allUsers')},
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.Manual, text: _i18n.t('addLiveReceptionistScript:manuallyControlUsers')},
            ];
            self.selectedUserTransferSelectionType = ko.observable(LiveReceptionistScriptTransferSelectionTypeConstants.All);
            self.showUserSelection = ko.observable(false);
            self.allUsers = ko.observableArray([]);
            self.selectedUsers = ko.observableArray([]);
            self.filterAvailableUsers = (allSubscribers, selectedSubscribers) => {
                return _filterAvailableSelections(allSubscribers, selectedSubscribers, 'name');
            };

            self.showSelectUserGroupSelectionTypes = ko.observable(false);
            self.availableUserGroupTransferSelectionTypes = [
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.All, text: _i18n.t('addLiveReceptionistScript:allUserGroups')},
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.Manual, text: _i18n.t('addLiveReceptionistScript:manuallyControlUserGroups')},
            ];
            self.selectedUserGroupTransferSelectionType = ko.observable(LiveReceptionistScriptTransferSelectionTypeConstants.All);
            self.showUserGroupSelection = ko.observable(false);
            self.allUserGroups = ko.observableArray([]);
            self.selectedUserGroups = ko.observableArray([]);
            self.filterAvailableUserGroups = (allSubscribers, selectedSubscribers) => {
                return _filterAvailableSelections(allSubscribers, selectedSubscribers, 'name');
            };

            self.showSelectForwardingNumberSelectionTypes = ko.observable(false);
            self.availableForwardingNumberTransferSelectionTypes = [
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.All, text: _i18n.t('addLiveReceptionistScript:allForwardingNumbers')},
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.Manual, text: _i18n.t('addLiveReceptionistScript:manuallyControlForwardingNumbers')},
            ];
            self.selectedForwardingNumberTransferSelectionType = ko.observable(LiveReceptionistScriptTransferSelectionTypeConstants.All);
            self.showForwardingNumberSelection = ko.observable(false);
            self.allForwardingNumbers = ko.observableArray([]);
            self.selectedForwardingNumbers = ko.observableArray([]);
            self.filterAvailableForwardingNumbers = (allSubscribers, selectedSubscribers) => {
                return _filterAvailableSelections(allSubscribers, selectedSubscribers, 'name');
            };

            self.showSelectVoicemailBoxSelectionTypes = ko.observable(false);
            self.availableVoicemailBoxTransferSelectionTypes = [
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.All, text: _i18n.t('addLiveReceptionistScript:allVoicemailBoxes')},
                {id: LiveReceptionistScriptTransferSelectionTypeConstants.Manual, text: _i18n.t('addLiveReceptionistScript:manuallyControlVoicemailBoxes')},
            ];
            self.selectedVoicemailBoxTransferSelectionType = ko.observable(LiveReceptionistScriptTransferSelectionTypeConstants.All);
            self.showVoicemailBoxSelection = ko.observable(false);
            self.allVoicemailBoxes = ko.observableArray([]);
            self.selectedVoicemailBoxes = ko.observableArray([]);
            self.filterAvailableVoicemailBoxes = (allSubscribers, selectedSubscribers) => {
                return _filterAvailableSelections(allSubscribers, selectedSubscribers, 'name');
            };

            self.isCompositionComplete = ko.observable(false);

            self.isImpersonating = ko.pureComputed(() => {
                return _sessionAccountInfo.isImpersonating();
            });

            self.dispose = () => {
                _disposables.forEach((disposable) => {
                    disposable.dispose();
                });

                _disposables = [];
            };

            self.detached = () => {
                self.isCompositionComplete(false);
            };

            self.compositionComplete = () => {
                self.isCompositionComplete(true);
            };

            self.activate = (selectedTransferCallerId,
                             selectedManualEntryTransferOption,
                             selectedUserTransferOption,
                             selectedUserTransferSelectionType,
                             allUsers,
                             selectedUsers,
                             selectedUserGroupTransferOption,
                             selectedUserGroupTransferSelectionType,
                             allUserGroups,
                             selectedUserGroups,
                             selectedForwardingNumberTransferOption,
                             selectedForwardingNumberTransferSelectionType,
                             allForwardingNumbers,
                             selectedForwardingNumbers,
                             selectedVoicemailBoxTransferOption,
                             selectedVoicemailBoxTransferSelectionType,
                             allVoicemailBoxes,
                             selectedVoicemailBoxes) => {
                self.selectedTransferCallerId = selectedTransferCallerId;
                self.selectedManualEntryTransferOption = selectedManualEntryTransferOption;

                self.selectedUserTransferOption = selectedUserTransferOption;
                self.selectedUserTransferSelectionType = selectedUserTransferSelectionType;
                self.allUsers = allUsers;
                self.selectedUsers = selectedUsers;

                self.selectedUserGroupTransferOption = selectedUserGroupTransferOption;
                self.selectedUserGroupTransferSelectionType = selectedUserGroupTransferSelectionType;
                self.allUserGroups = allUserGroups;
                self.selectedUserGroups = selectedUserGroups;

                self.selectedForwardingNumberTransferOption = selectedForwardingNumberTransferOption;
                self.selectedForwardingNumberTransferSelectionType = selectedForwardingNumberTransferSelectionType;
                self.allForwardingNumbers = allForwardingNumbers;
                self.selectedForwardingNumbers = selectedForwardingNumbers;

                if (self.allForwardingNumbers().length === 0) {
                    self.availableForwardingNumberTransferOptions([{id: LiveReceptionistTransferOptionConstants.None, text: _i18n.t('addLiveReceptionistScript:transferOptionNone')}]);
                    self.selectedForwardingNumberTransferOption(LiveReceptionistTransferOptionConstants.None);
                    self.selectedForwardingNumberTransferSelectionType(LiveReceptionistScriptTransferSelectionTypeConstants.All);
                }

                self.selectedVoicemailBoxTransferOption = selectedVoicemailBoxTransferOption;
                self.selectedVoicemailBoxTransferSelectionType = selectedVoicemailBoxTransferSelectionType;
                self.allVoicemailBoxes = allVoicemailBoxes;
                self.selectedVoicemailBoxes = selectedVoicemailBoxes;

                return _initialize();
            };

            const _initialize = () => {
                return _promiseFactory.defer((initPromise) => {
                    _onUserTransferOptionChange();
                    _onUserGroupTransferOptionChange();
                    _onForwardingNumberTransferOptionChange();
                    _onVoicemailBoxTransferOptionChange();

                    _disposables.push(self.selectedUserTransferOption.subscribe(_onUserTransferOptionChange));
                    _disposables.push(self.selectedUserTransferSelectionType.subscribe(_onUserTransferSelectionTypeChange));
                    _disposables.push(self.selectedUserGroupTransferOption.subscribe(_onUserGroupTransferOptionChange));
                    _disposables.push(self.selectedUserGroupTransferSelectionType.subscribe(_onUserGroupTransferSelectionTypeChange));
                    _disposables.push(self.selectedForwardingNumberTransferOption.subscribe(_onForwardingNumberTransferOptionChange));
                    _disposables.push(self.selectedForwardingNumberTransferSelectionType.subscribe(_onForwardingNumberSelectionTypeChange));
                    _disposables.push(self.selectedVoicemailBoxTransferOption.subscribe(_onVoicemailBoxTransferOptionChange));
                    _disposables.push(self.selectedVoicemailBoxTransferSelectionType.subscribe(_onVoicemailBoxSelectionTypeChange));
                    initPromise.resolve();
                });
            };
        };
    });

